(function($) {

    function slider() {
        if ($('.js_featured_carousel_hooverdc, .fellow-slider').length > 0) {
            setTimeout(function() {
                $(".fellow-slider").css({ "opacity": "1" });
            }, 500);
            $('.fellow-slider .slider-wrapper').not('.slick-initialized').slick({
                infinite: false,
                slidesToShow: 2,
                slideToScroll: 1,
                responsive: [{
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    },

                ]
            });
        }
    }

    var currentUrl = window.location.pathname;
    $(document).on('click', '.fellow-slider .slider-wrapper .slick-prev', function() {
        console.log('previous click');
        dataLayer.push({event: 'fellow_slider_arrow_click', event_category: 'Fellow Slider Arrow Click', event_label: 'Fellow Slider Previous Click', page_url: currentUrl});
    });
    $(document).on('click', '.fellow-slider .slider-wrapper .slick-next', function() {
        console.log('next click');
        dataLayer.push({event: 'fellow_slider_arrow_click', event_category: 'Fellow Slider Arrow Click', event_label: 'Fellow Slider Next Click', page_url: currentUrl});    
    });

    $(document).ready(function() {
        slider();
    });
    $(window).on("load", function() {
        slider();
    });
})(jQuery);